<template>
  <section
    id="hero"
    class="hero"
  >
    <div class="hero-section">
      <div
        class="sphere"
        :class="`position-${activeDev.id}`"
      ></div>
      <div class="hero-wrapper container">
        <div class="title-wrapper">
          <p class="remote-careers">Remote careers</p>
          <h1 class="title">
            Grow your
            <span class="role">
              <span id="role">{{ activeDev.generalRole }}</span>
            </span>
            <br />
            career, land your
            <br />
            dream job
          </h1>
          <p class="subtitle">
            Get matched with top, remote jobs matching your profile. Gain access
            to expert coaching, CV review, mock interviews, and more.
          </p>
          <div class="buttons">
            <ApplyButton
              page-name="homepage"
              cta-section="hero"
              class="proxify-btn proxify-btn-white"
            />
            <Glassdoor />
          </div>
          <div class="data-information">
            <div>
              <CheckIcon color="green" />
              300+ new jobs every month in engineering, data, AI, and more
            </div>
          </div>
        </div>
        <div class="developers-wrapper">
          <div class="developers">
            <div
              v-for="dev in devs"
              :key="`${dev.alt}-active`"
              class="developer-card fade-in"
              :class="[{ active: dev.active }, dev.alt]"
              @click="makeNextDevActive(true)"
            >
              <NuxtPicture
                :key="dev.alt"
                :class="[`${dev.alt}`, { hidden: dev.active }]"
                :src="`/images/home-page/hero/${dev.alt}.png`"
                :alt="dev.alt"
              />
              <NuxtPicture
                :key="`${dev.alt}-second`"
                :class="[`${dev.alt}`, { hidden: !dev.active }]"
                :src="`/images/home-page/hero/${dev.alt}-active.png`"
                :alt="dev.alt"
              />
            </div>
            <div class="illustrations">
              <NuxtImg
                v-for="dev in devs"
                :key="`illustration-${dev.alt}`"
                :class="`dev-cover ${dev.active ? dev.alt : 'default'}-cover`"
                :src="`/images/home-page/hero/${dev.alt}-cover.svg`"
                :alt="`illustration-${dev.alt}`"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container benefit-section-container">
      <BenefitsSection />
      <div
        class="cube"
        :class="`position-${activeDev.id}`"
      ></div>
    </div>
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import Glassdoor from '~/components/Common/Glassdoor/Glassdoor.vue';
import BenefitsSection from '~/components/Common/BenefitsSection/BenefitsSection.vue';
import CheckIcon from '~/components/Common/Svg/CheckIcon.vue';

export default {
  components: {
    ApplyButton,
    CheckIcon,
    Glassdoor,
    BenefitsSection,
  },
  data() {
    return {
      devs: [
        {
          id: 1,
          alt: 'dev1',
          name: 'Oleksandra Hutsemekers',
          generalRole: 'frontend',
          role: 'Frontend Developer',
          active: true,
        },
        {
          id: 2,
          alt: 'dev2',
          name: 'Furkan Caglar',
          generalRole: 'fullstack',
          role: 'Fullstack Developer',
          active: false,
        },
        {
          id: 3,
          alt: 'dev3',
          name: 'Doruk Geziki',
          generalRole: 'backend',
          role: 'Backend Developer',
          active: false,
        },
      ],
      interval: [],
    };
  },
  computed: {
    activeDev() {
      return this.devs.find((developer) => developer.active);
    },
  },
  mounted() {
    this.startInterval();
  },
  beforeUnmount() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  },
  methods: {
    makeNextDevActive(manual = false) {
      if (manual) {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
      }

      this.animate(100, 0, 10);

      this.timeout = setTimeout(() => {
        const devs = this.devs;
        this.devs[0].active = false;
        this.devs[1].active = true;
        const firstElement = devs.shift();
        this.devs.push(firstElement);

        this.animate(0, 100, 60);
      }, 100);
      if (manual) {
        this.startInterval();
      }
    },
    startInterval() {
      this.interval = setInterval(() => {
        this.makeNextDevActive();
      }, 4000);
    },
    animate(initialWidth, finalWidth, duration, currentWidth = initialWidth) {
      const roleElement = document.getElementById('role');

      if (!roleElement) {
        return;
      }

      roleElement.style.width = `${currentWidth}%`;

      const nextWidth =
        initialWidth < finalWidth ? currentWidth + 10 : currentWidth - 10;

      if (currentWidth !== finalWidth) {
        setTimeout(() => {
          this.animate(initialWidth, finalWidth, duration, nextWidth);
        }, duration);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
